import {createSelector} from 'reselect';
import props from '../../../props';

export default createSelector(
    props.lootbox.box,
    (box) => {
        return {
            box
        }
    }
)